import { CSSProperties } from 'react'
import { Position } from 'types'

export function useCropStyles(crop?: Position): CSSProperties[] {
    if (!crop) {
        return [{}, {}]
    }

    return [
        {
            height: crop.height,
            overflow: 'hidden',
            width: crop.width,
        },
        {
            transform: `translate3d(${-crop.x}px, ${-crop.y}px, 0)`,
        },
    ]
}
